export default {
  SET_PERMISSIONS: 'SET_PERMISSIONS',
  UPDATE_PERMISSIONS: 'UPDATE_PERMISSIONS',
  CLEAR_PERMISSIONS: 'CLEAR_PERMISSIONS',
};



// WEBPACK FOOTER //
// ./src/reducers/permissions/types.js